import { Header } from 'header'
import { AppFooter, Explore as View } from 'ui-components'

import { TAppProps } from '..'
import { PopularMaps } from './PopularMaps'
import { PrimaryTags } from './PrimaryTags'
import { SecondaryTags } from './SecondaryTags'

const Explore = (props: TAppProps) => {
  return (
    <View
      slots={{
        Header,
        PrimaryTags: () => (
          <PrimaryTags initialData={props.getPrimaryTagsResults} />
        ),
        SecondaryTags: () => (
          <SecondaryTags initialData={props.getSecondaryTagsResults} />
        ),
        PopularMaps: () => (
          <PopularMaps initialData={props.getPopularMapsResults} />
        ),
        Footer: AppFooter
      }}
    />
  )
}

export { Explore }
